module.exports = __webpack_public_path__ + "img/suisse.49032a3a.png";